import Vue from 'vue'
import i18n from '@/utils/i18n'
let pwd = ''

const initRegData = () => {
  return {
      // ExPhone: /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(18[0-9]{1}))+\d{8})$/, // 手机号
      ExPassword: {
          reg: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/,
          errMsg: i18n.t('密码由英文大小写和数字组成')
      },
      ExNum: {
          reg: /^\d+$/,
          errMsg: i18n.t('只能是正整数')
      },
      ExNumVal: {
          reg: /^[-|+]?\d+(\.\d+)?$/,
          errMsg: i18n.t('只能是数值')
      },
      ExPNum: {
          reg: /^\d+(\.\d+)?$/,
          errMsg: i18n.t('只能是正数')
      },
      ExNotZeroPNumber: {
          reg: /^[1-9]+|[0-9]\.\d+$/,
          errMsg: i18n.t('只能是不为零的正数')
      },
      ExModel: {
          reg: /^[a-zA-Z0-9-]+$/,
          errMsg: i18n.t('只能输入英文、数字和\'-\'')
      },
      ExEnNum: {
          reg: /^[a-zA-Z0-9]+$/,
          errMsg: i18n.t('只能输入英文和数字')
      },
      ExCn: {
          reg: /^[\u4E00-\u9FA5]+$/,
          errMsg: i18n.t('只能输入中文')
      },
      ExEn: {
          reg: /^[a-zA-Z]+$/,
          errMsg: i18n.t('只能输入英文')
      },
      ExCnEn: {
          reg: /^[a-zA-Z\u4E00-\u9FA5]+$/,
          errMsg: i18n.t('只能输入中、英文')
      },
      ExCnEnNum: {
          reg: /^[a-zA-Z0-9\u4E00-\u9FA5]+$/,
          errMsg: i18n.t('只能输入中文、英文和数字')
      },
      ExEnSpace: {
          reg: /^[a-zA-Z\s]+$/,
          errMsg: i18n.t('只能输入英文和空格')
      },
      ExCnEnSpace: {
          reg: /^[a-zA-Z\s\u4E00-\u9FA5]+$/,
          errMsg: i18n.t('只能输入中、英文、空格')
      },
      ExPhone1: {
          reg: /^(\d{11})|^(([\d/(/)]{7,10})|([\d/(/)]{6}|[\d/(/)]{5}|[\d/(/)]{4}|[\d/(/)]{3}|[\d/(/)]{2})-([\d/(/)]{7,10})|([\d/(/)]{6}|[\d/(/)]{5}|[\d/(/)]{4}|[\d/(/)]{3}|[\d/(/)]{2})-([\d/(/)]{7,10})-([\d/(/)]{6}|[\d/(/)]{5}|[\d/(/)]{4}|[\d/(/)]{3}|[\d/(/)]{2}|[\d/(/)]{1})|([\d/(/)]{7,10})-([\d/(/)]{6}|[\d/(/)]{5}|[\d/(/)]{4}|[\d/(/)]{3}|[\d/(/)]{2}|[\d/(/)]{1}))+$/,
          errMsg: i18n.t('请输入正确的号码')
      },
      ExPhone: {
          reg: /^\d{6,11}$/,
          errMsg: i18n.t('请输入正确的号码')
      },
      ExPhone2: {
          reg: /^\d{6,15}$/,
          errMsg: i18n.t('请输入正确的号码')
      },
      ExEmail: {
          reg: /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/,
          errMsg: i18n.t('请输入正确的邮箱地址')
      },
      ExZip: {
          reg: /^[0-9]{6}$/,
          errMsg: i18n.t('请输入正确的邮政编号')
      },
      ExCellphone: {
          reg: /^([0-9]{3,4}-)?[0-9]{7,8}$/,
          errMsg: i18n.t('请输入正确的座机号')
      },
      ExBankcard: {
          reg: /^([1-9]{1})(\d{14}|\d{18})$/,
          errMsg: i18n.t('请输入正确的银行卡号')
      },
      ExIdentity: {
          reg: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
          errMsg: i18n.t('请输入正确的身份证号')
      },
      ExMoney: {
          reg: /(^[1-9](\d+)?(\.\d{1,2})?$)|(^[1-9]$)|(^\d\.[1-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
          errMsg: i18n.t('请输入正确的金额')
      },
      ExDomain: {
          reg: /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/,
          errMsg: i18n.t('请输入正确的浏览器地址')
      }
  }
}

const validateRules = (rule, value, callback) => {
  const regData = initRegData()
  // 参数校验
  // if (rule.field) {}
  if (!rule.required && !value) {
      callback()
  } else if (rule.required && value !== 0 && !value) {
      callback(new Error(rule.msg || i18n.t('内容不能为空')))
  } else if (rule.min && rule.max) {
      // 判断位数限制
      if (value.length >= rule.min && value.length <= rule.max) {
          startMatch()
      } else {
          callback(new Error(i18n.t('内容长度为', {
              min: rule.min,
              max: rule.max
          })))
      }
  } else if (rule.min && !rule.max) {
      if (value.length >= rule.min) {
          startMatch()
      } else {
          callback(new Error(i18n.t('内容长度最小为', { min: rule.min })))
      }
  } else if (!rule.min && rule.max) {
      if (value.length <= rule.max) {
          startMatch()
      } else {
          callback(new Error(i18n.t('内容长度最大为', { max: rule.max })))
      }
  } else if (rule.maxNum) {
      if (value > rule.maxNum) {
          callback(new Error(i18n.t('数量不能大于', { max: rule.maxNum })))
      } else {
          startMatch()
      }
  } else {
      startMatch()
  }

  // 开始匹配
  function startMatch() {
      if (rule.regType) {
          matchRule()
      } else {
          callback()
      }
  }

  // 规则匹配
  function matchRule() {
      switch (rule.regType) {
          case 'ExPassword':
              pwd = value
              validateMethod(regData[rule.regType].reg)
              break
          case 'ExConfirmPwd':
              if (value === '') {
                  callback(new Error(i18n.t('请再次输入密码')))
              } else if (value !== pwd) {
                  callback(new Error(i18n.t('两次密码输入不一致')))
              } else {
                  callback()
              }
              break
          case 'ExArray':
              if (value?.length > 0) {
                  callback()
              } else {
                  callback(new Error(rule.message ?? i18n.t('请选择')))
              }
              break
          default:
              validateMethod(regData[rule.regType].reg)
              break
      }
  }

  // 验证规则
  function validateMethod(reg) {
      if (reg.test(value)) {
          // 判断rules中对应字段的属性中是否存在exists属性，true验证存在性
          if (rule.exists) {
              // checkExists()
          } else {
              callback()
          }
      } else {
          callback(new Error(regData[rule.regType].errMsg))
      }
  }

  // function checkExists() {
  //     // 获取当前身份信息
  //     const ident = store.getters.subjectType

  //     switch (rule.existsType) {
  //         case 'loginEmail': // 失去焦点检测邮箱
  //             // 展商 邮箱登录检测
  //             if (ident === 'ACTOR') {
  //                 app.func.checkUser({
  //                     email: value,
  //                     validCodeKey: rule.validCodeKey
  //                 }, callback)
  //             } else {
  //                 // 观众 邮箱登录
  //                 app.func.validateEmail({
  //                     email: value,
  //                     validCodeKey: rule.validCodeKey
  //                 }, rule.existsType, callback)
  //             }
  //             break
  //         case 'loginMobile': // 失去焦点检测手机号 是否已注册
  //             // 展商登 手机号录检测
  //             if (ident === 'ACTOR') {
  //                 app.func.checkUser({
  //                     mobile: value,
  //                     validCodeKey: rule.validCodeKey
  //                 }, callback)
  //             } else {
  //                 // 观众手机号检测（发送验证码时）
  //                 app.func.validateMobile({
  //                     mobile: value,
  //                     validCodeKey: rule.validCodeKey
  //                 }, rule.existsType, callback)
  //             }
  //             break
  //         case 'registerEmail':
  //             app.func.validateEmail({
  //                 email: value,
  //                 validCodeKey: rule.validCodeKey
  //             }, rule.existsType, callback)
  //             break
  //         case 'registerMobile':
  //             app.func.validateMobile({
  //                 mobile: value,
  //                 validCodeKey: rule.validCodeKey
  //             }, rule.existsType, callback)
  //             break
  //         default:
  //             callback()
  //             break
  //     }
  // }
}
    

// export {
//   initRegData,
//   validateRules
// }

Vue.prototype.validateRules = validateRules
Vue.prototype.regData = initRegData()
